import RMVideoLossModal from './RM_video_loss-modal.vue'
export default RMVideoLossModal
